'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgWelloPoint } from '@common/icon';
import { closeResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { LottoPotGauge } from '../../_components/LottoPotGauge';
import { useLottoPool } from '../_hooks/useLottoPool';
export type LotteryResultVariant = 'won' | 'lost-remaining' | 'lost-exhausted';
const LotteryProgressSummary = () => {
  const $ = _c(6);
  const {
    data
  } = useLottoPool();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="font-600 text-Gray-900 typo-body4">행운권 로또 진행상황</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = data.potGauge;
  let t2;
  if ($[1] !== data.accumulatedAmount) {
    t2 = data.accumulatedAmount.toLocaleString();
    $[1] = data.accumulatedAmount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${t2}원`;
  let t4;
  if ($[3] !== data.potGauge || $[4] !== t3) {
    t4 = <div className="flex flex-col gap-8 rounded-small bg-Gray-50 p-16">{t0}<LottoPotGauge {...t1} accumulatedAmountLabel={t3} /></div>;
    $[3] = data.potGauge;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};

//* 당첨 금액은 응모 응답(wonPoint)이 진실 — 누적 상금(pool)은 지급 후 리셋될 수 있어 표시용으로 못 쓴다.
const WonBody = t0 => {
  const $ = _c(9);
  const {
    wonPoint
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-4"><h2 className="font-700 text-Gray-900 typo-h7">축하합니다 당첨되었습니다!</h2><p className="font-400 text-Gray-600 typo-body4">앞으로도 행운권 로또에 많은 관심과 참여 부탁드립니다</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SvgWelloPoint className="size-64" originalFill={true} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== wonPoint) {
    t3 = wonPoint.toLocaleString();
    $[2] = wonPoint;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex flex-col items-center gap-4">{t2}<p className="font-700 text-Gray-black typo-h5">{t3}P 받았어요</p></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Button className="w-full" onClick={closeResponsiveDialog}>확인</Button>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <div className="flex flex-col gap-28">{t1}{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};

//* 재응모는 다이얼로그에서 제공하지 않는다 — 응모는 시청 이력과 원자 계약이라
//* 닫고 허브의 응모 버튼(게이트→리워드영상)으로만 다시 진입한다.
const LostRemainingBody = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-16"><div className="flex flex-col gap-4"><h2 className="font-700 text-Gray-900 typo-h7">아쉽지만 당첨되지 않았어요</h2><p className="font-400 text-Gray-600 typo-body4">이번 응모는 당첨되지 않았지만, 아직 응모권이 남았어요</p></div><LotteryProgressSummary /><Button className="w-full" onClick={closeResponsiveDialog}>확인</Button></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const LostExhaustedBody = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-16"><div className="flex flex-col gap-4"><h2 className="font-700 text-Gray-900 typo-h7">아쉽지만 당첨되지 않았어요</h2><p className="font-400 text-Gray-600 typo-body4">이번 응모는 당첨되지 않았지만, 다시 도전해봐요</p></div><LotteryProgressSummary /><Button className="w-full" onClick={closeResponsiveDialog}>행운권 얻으러 가기</Button></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
interface LotteryResultContentProps {
  variant: LotteryResultVariant;
  wonPoint?: number;
}
export const LotteryResultContent = t0 => {
  const $ = _c(4);
  const {
    variant,
    wonPoint
  } = t0;
  if (variant === "won") {
    const t1 = wonPoint ?? 0;
    let t2;
    if ($[0] !== t1) {
      t2 = <WonBody wonPoint={t1} />;
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (variant === "lost-remaining") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LostRemainingBody />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LostExhaustedBody />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};